import Vue from 'vue'
import Vuex from 'vuex'
import {checkUserMfaExist} from "../api/sys/user";
import setting from './modules/setting';
import { getButtonLimit } from '../api/permission';
import { setBtnAuth } from '../utils/btnAuth';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    setting
  },
  state: {
    rightMenu: {
      status: "none",
      top: "0px",
      left: "0px",
      list: []
    },
    // 0:无 1:有
    hasMfa: 0,
    language: 1,
    regionCode: "us-east-1",
    btnAuth: null, // 当前路径对应的按钮权限
    allBtnAuth: null, // 当前路径对应的按钮权限
  },
  getters: {
    startMonth: state => {
      return state.setting.startMonth
    },
    endMonth: state => state.setting.endMonth,
    siteSetting: state => state.setting.siteSetting,
    monthList: state => state.setting.monthList,
    region: state => state.regionCode,
    // levelOptions: state => state.setting.levelOptions,
  },
  mutations: {
    // 更新右键菜单数据
    updateRightMenuStatus(state, menuObj) {
      state.rightMenu.status = menuObj.status;
      state.rightMenu.top = menuObj.top;
      state.rightMenu.left = menuObj.left;
      state.rightMenu.list = menuObj.list;
    },
    // 更新是否已绑定MFA
    SET_MFA(state, hasMfa) {
      state.hasMfa = hasMfa;
    },
    SET_LANGUAGE(state, language) {
      state.language = language;
    },
    SET_REGION_CODE(state, regionCode) {
      state.regionCode = regionCode;
    },
    SET_BTN_AUTH(state, btnAuth) {
      state.btnAuth = btnAuth;
    },
    SET_ALL_BTN_AUTH(state, allBtnAuth) {
      setBtnAuth(allBtnAuth)
      state.allBtnAuth = allBtnAuth;
    },
  },
  actions: {
    // 异步更新是否已绑定MFA
    updateHasMfaAsync({commit}) {
        return new Promise((resolve, reject) => {
          checkUserMfaExist().then(res => {
            if (res.success) {
              // 记录用户的mfa状态
              commit('SET_MFA', res.data);
            }
            resolve(res)
          }).catch(res => {
            reject(res)
          })
        })
    },

    /** 
     * 异步更新按钮权限
     * @param uniqueCode 页面对应的key
     */ 
   updateBtnAuthAsync({ commit }, uniqueCode) {
      return new Promise((resolve, reject) => {
        getButtonLimit({ uniqueCode })
          .then(res => {
            if (res.success && res.data) {
              resolve(res.data)
            } else {
              reject(new Error('权限获取失败'))
            }
          })
          .catch(error => {
            reject(new Error(`接口请求失败: ${error.message}`))
          })
      })
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js